module.exports = __webpack_public_path__ + "media/images/strategic-partners/medical-device-depot-47627072122298f98104a45cc50dae6a.png";